import { api as userApi, fetcher as userFecther } from "@api/_base_user";
import { API_MESSAGE } from "@const/api-messages.const";
import { ApiResponse } from "@interfaces/dto/swr.dto";
import {
  WishlistProductInputDto,
  WishlistProductsResponse,
} from "@interfaces/dto/user-data.dto";
import useSWR from "swr";

export const updateProductWishlist = async ({
  productId,
  isWishlist,
}: WishlistProductInputDto): Promise<ApiResponse> => {
  try {
    if (isWishlist) {
      await userApi.post(`/wishlist/${productId}`);
      return { isOk: true, message: "บันทึกสินค้าเข้าสู่รายการโปรด" };
    } else {
      await userApi.delete(`/wishlist/${productId}`);
      return { isOk: true, message: "ลบสินค้าออกจากรายการโปรด" };
    }
  } catch (error: any) {
    const errorMessage: string =
      error.response.data.message ?? API_MESSAGE.INTERNAL_ERROR;
    return { isOk: false, message: errorMessage };
  }
};

export const useWishlistProducts = (): WishlistProductsResponse => {
  const { data, error, mutate } = useSWR(`/wishlist`, userFecther);

  return {
    data: data,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};
